import React from "react";
import { Image } from "react-bootstrap";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import moment from "moment";
import {
  ORDER_TYPE,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
  ORDER_STATUS,
} from "../../../enums/OrderEnums";
import NoContent from "../../reusableComponents/NoContentComponent";

function TableHeadEvents(props) {
  return (
    <tr>
      <th style={{ width: "12%" }}>Transaction ID</th>
      <th style={{ width: "15%" }}>User Name</th>
      <th style={{ width: "20%" }}>
        Experience Name/ ID/ <br />
        Experience Type
      </th>
      <th style={{ width: "15%" }}>
        Total PAX/
        <br /> Experience request ID
      </th>
      <th style={{ width: "15%" }}>
        Payment Method/ <br />
        Payment Status
      </th>
      <th style={{ width: "10%" }}>Date & Time</th>
      <th style={{ width: "10%" }}>Amount</th>
    </tr>
  );
}

export default TableHeadEvents;

export const TableBodyEvents = (props) => {
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              {props.auth.secondary_loader ? (
                <SmallLoader />
              ) : (
                !isEmpty(props.paymentOrder) ?
                  props?.paymentOrder
                    .slice(props?.start, props?.end)
                    .map((item, index) => {
                      return (
                        <tr
                          className="sd_body_table-row"
                          // style={{ textAlign: "center" }}
                          key={index}
                        >
                          <td
                            style={{
                              width: "12%",
                              paddingLeft: "1.75rem",
                            }}
                          >
                            <div className="f12-500">
                              {item?.transactionNumber || item?._id}
                            </div>
                          </td>
                          <td style={{ width: "15%" }} className="text-center">
                            <div className="d-flex align-items-center">
                              <div className="super-admin-suggestion-table-body-boxone">
                                {item?.user_id?.profile_photo[0] ? (
                                  <div className="super-admin-suggestion-imageBoxOne enIMG33">
                                    <Image
                                      fluid
                                      src={item?.user_id?.profile_photo[0]}
                                      alt="Icon"
                                      className="rounded-circle"
                                    />
                                  </div>
                                ) : (
                                  <div className="super-admin-suggestion-imageBoxOne enIMG33">
                                    <Image
                                      fluid
                                      src={require("../../../assets/images/ActionImages/demoprofile.jpg")}
                                      alt="Icon"
                                      className="rounded-circle"
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="super-admin-suggestion-imageBoxTwo ml-2">
                                <div className="f12-500">
                                  {item?.user_id?.first_name}{" "}
                                  {item?.user_id?.last_name}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={{ width: "20%" }}>
                            <div className="d-flex">
                              <div>
                                <img
                                  src={
                                    item?.expRequestId?.experienceId?.photos[0]
                                  }
                                  width="35px"
                                />
                              </div>
                              &nbsp;&nbsp;&nbsp;
                              <div>
                                <div className="f12-500">
                                  {item?.expRequestId?.experienceId?.name}
                                </div>
                                <div className="f10-400">
                                  {item?.expRequestId?.experienceId?.expId}
                                </div>
                                <div className="f10-400">
                                  {item?.expRequestId?.expType}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={{ width: "15%" }}>
                            <div className="f12-500">
                              {parseInt(item?.expRequestId?.kidsCount) +
                                parseInt(item?.expRequestId?.adultCount) + item?.expRequestId?.package?.adults + item?.expRequestId?.package?.kids}
                              /<br />
                              {item?.expRequestId?.requestId}
                            </div>
                          </td>
                          <td style={{ width: "15%" }}>
                            <div className="f12-500">
                              {
                                PAYMENT_TYPE[
                                item?.expRequestId?.paymentData?.paymentMethod
                                ]
                              }
                            </div>
                            {/* <div className="badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>{PAYMENT_STATUS[item?.event_request_id?.payment_status]}</div> */}
                            {item?.expRequestId?.paymentStatus === 0 ? (
                              <div
                                className="badge badge-warning p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                {
                                  PAYMENT_STATUS[item?.expRequestId?.paymentStatus === 0]
                                }
                              </div>
                            ) : null}
                            {item?.expRequestId?.paymentStatus === 1 ? (
                              <div
                                className="badge badge-success p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                {
                                  PAYMENT_STATUS[
                                  item?.expRequestId?.paymentStatus
                                  ]
                                }
                              </div>
                            ) : null}
                            {item?.expRequestId?.paymentStatus === 2 ? (
                              <div
                                className="badge badge-danger p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                {
                                  PAYMENT_STATUS[
                                  item?.expRequestId?.paymentStatus
                                  ]
                                }
                              </div>
                            ) : null}
                            {item?.expRequestId?.paymentStatus === 3 ? (
                              <div
                                className="badge badge-danger p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                {
                                  PAYMENT_STATUS[
                                  item?.expRequestId?.paymentStatus
                                  ]
                                }
                              </div>
                            ) : null}
                            {item?.expRequestId?.paymentStatus === 4 ? (
                              <div
                                className="badge badge-info p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                {
                                  PAYMENT_STATUS[
                                  item?.expRequestId?.paymentStatus
                                  ]
                                }
                              </div>
                            ) : null}
                          </td>

                          <td style={{ width: "10%" }}>
                            <div className="f12-400">
                              {moment(item?.createdAt).format("Do MMM YYYY")}
                            </div>
                            <div className="f12-400">
                              {moment(item?.createdAt).format("hh:mm A")}
                            </div>
                          </td>
                          <td style={{ width: "10%" }}>
                            <div className="f12-500">₹ {item?.amount}</div>
                          </td>
                        </tr>
                      );
                    }) : <NoContent />
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
